import axios from 'axios'
import * as tokenPrc from '@/js/tokenProcess'
// import {authAPI} from '@/api/restfulAPI'
import Qs from 'qs'
// import * as glbData from '@/js/globalData'

// const TOLERATE_EXP_TS = 5 * 60
const DOMAIN_KEY = 'wise-paas'
const DEF_REST_PREFIX = '/api'
// const TOKEN_INVALID_CODE = 4012
const REST_PREFIX = getRestPrefix()
const REST_BASEURL = getBaseURL()

axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.response.use(response => {
  return response.data
}, error => {
  let errInfo = {}
  if (error.response != null) {
    errInfo = {
      data: error.response.data == null ? null : error.response.data,
      errCode: error.response.status
    }
    if (errInfo.errCode === 401) {
      console.log('go 401')
      // tokenPrc.setSession('login', 'true')
      tokenPrc.clearToken()
      // window.location.href = '/#/zh/login'
      window.location.reload()
      // tokenPrc.clearToken()
      // this.$router.push({name: glbData.LOGIN_CMPN})
    }
    // console.log(errInfo)
    // if (errInfo.errCode === 401 && (errInfo.data !== null && errInfo.data.code === TOKEN_INVALID_CODE)) {
    //   tokenPrc.clearToken()
    // }
  }
  return Promise.reject(errInfo)
})

// axios.interceptors.request.use(config => {
//   // console.log('interceptors')
//   let exp = tokenPrc.getExpFromToken()
//   // console.log(exp)
//   if (exp != null) {
//     let nowTs = new Date().getTime() / 1000
//     // console.log(nowTs)
//     if (exp < nowTs || exp - nowTs < TOLERATE_EXP_TS) {
//       if (!(config.url === '/api/login' || config.url === '/api/login/refresh')) {
//       // if (!((config.url.slice(-'login'.length).toLowerCase() === 'refresh' ||
//       // config.url.slice(-'refresh/token'.length).toLowerCase() === 'refresh/token') &&
//       // config.method.toLowerCase() === 'get')) {
//         authAPI.refreshToken().then(data => {
//           console.log('refresh')
//           // tokenPrc.setToken(data.data)
//         }).catch(error => {
//           console.log(error)
//         })
//       }
//     }
//     // if (exp - nowTs > 0 && exp - nowTs < TOLERATE_EXP_TS) {
//     //   console.log('expire')
//     //   if (!((config.url.slice(-'login'.length).toLowerCase() === 'login' ||
//     //   config.url.slice(-'refresh/token'.length).toLowerCase() === 'refresh/token') &&
//     //   config.method.toLowerCase() === 'get')) {
//     //     authAPI.refreshToken().then(data => {
//     //       console.log('refresh')
//     //       tokenPrc.setToken(data.token)
//     //     }).catch(error => {
//     //       console.log(error)
//     //     })
//     //   }
//     // }
//   }
//   return config
// })

function ajaxRest ({url, method, data = {},
  timeout = {server: 5000, client: 5000},
  pathPrefix = REST_PREFIX,
  responseType = 'json'}) {
  let p = new Promise((resolve, reject) => {
    let urlParams = {}
    let bodyData = {}
    if (method === 'GET') {
      urlParams = {_now: Date.now(), ...data}
    } else bodyData = data

    let config = {
      url: `${pathPrefix}${url}`,
      baseURL: REST_BASEURL,
      method: method,
      params: urlParams,
      paramsSerializer: function (params) {
        return Qs.stringify(params, {arrayFormat: 'repeat'})
      },
      data: bodyData,
      timeout: timeout.client,
      responseType: responseType
    }

    let token = tokenPrc.getAuthenFromToken()
    if (token != null) {
      config.headers = {
        'Authorization': token
      }
    }

    axios.request(config).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })

  return p
}

function ajaxRestRoot ({url, method, data = {},
  timeout = {server: 5000, client: 5000},
  responseType = 'json'}) {
  let p = new Promise((resolve, reject) => {
    let urlParams = {}
    let bodyData = {}
    if (method === 'GET') {
      urlParams = {_now: Date.now(), ...data}
    } else bodyData = data

    let config = {
      url: `${url}`,
      baseURL: REST_BASEURL,
      method: method,
      params: urlParams,
      paramsSerializer: function (params) {
        return Qs.stringify(params, {arrayFormat: 'repeat'})
      },
      data: bodyData,
      timeout: timeout.client,
      responseType: responseType
    }

    let token = tokenPrc.getAuthenFromToken()
    if (token != null) {
      config.headers = {
        'Authorization': token
      }
    }

    axios.request(config).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })

  return p
}

function getBaseURL () {
  let baseUrl = ''
  if (window.location.origin.search(DOMAIN_KEY) !== -1) {
    // let reg = new RegExp('-\\d+-\\d+-\\d+')
    // baseUrl = window.location.origin.replace(reg, '').replace('portal', 'api')
    // baseUrl = 'https://sc-composer-001.wise-paas.com'
    baseUrl = window.location.origin
  }
  return baseUrl
}

function getRestPrefix () {
  let prefix = '/api'
  if (window.location.origin.search(DOMAIN_KEY) === -1) {
    prefix = DEF_REST_PREFIX
  }
  return prefix
}

export {ajaxRest, ajaxRestRoot}



// WEBPACK FOOTER //
// ./src/api/ajaxBase.js